import React from "react";
import {Popper} from "@material-ui/core";

export default props => <Popper {...props} placement="bottom-start" />;
